export default __webpack_public_path__ + "static/media/undraw_season_change_f99v.ada8e9d6.svg";